import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { handleDeleteItem } from "./HandleDeleteFunction";
import { setEmergencyContactes } from "../../Slices/employeeslice";
import { InputField } from "../../blueplanitUtils/InputField";
import Modal from "../../blueplanitUtils/Modal";
import { handleClose } from "./HandleClosePop/handleclose";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
export const EmergencyContactModelPopUp = () => {
    const dispatch = useDispatch();
    const { handleSubmit } = useFormHandler();
    const [isContactsValid, setIsContactsValid] = useState(false);
    const [emergencyContacts, setEmergencyContacts] = useState([]);
    const contactup = useSelector((state) => state.employee.emergencyContacts);
    useEffect(() => {
        setEmergencyContacts(contactup)
    }, [contactup])

    const mobilePattern = /^[6-9]\d{9}$/;
    const validateEmergencyContact = (contact) => {
        let errors = {};
        if (!contact.name?.trim()) {
            errors.name = "Name is required";
        } else if (!/^[A-Za-z\s-]+$/.test(contact.name)) {
            errors.name = "Only letters, spaces, and hyphens allowed";
        }
        if (!contact.relationship?.trim()) {
            errors.relationship = "Relationship is required";
        } else if (!/^[A-Za-z\s-]+$/.test(contact.relationship)) {
            errors.relationship = "Only letters, spaces, and hyphens allowed";
        }

        if (!contact.phoneNumber?.trim()) {
            errors.phoneNumber = "Enter phone number";
        } else if (!mobilePattern.test(contact.phoneNumber)) {
            errors.phoneNumber = "Enter a valid 10-digit phone number";
        }
        
        return errors;
    };


    const [contactErrors, setContactErrors] = useState({});
    // Inline Validation on Change
    const handleEmergencyChange = (index, e) => {
        const { name, value } = e.target;
        const updatedContacts = [...emergencyContacts];
        updatedContacts[index] = { ...updatedContacts[index], [name]: value };
        setEmergencyContacts(updatedContacts);

        // Validate and update errors
        const updatedErrors = { ...contactErrors };
        const contactErrorsForIndex = validateEmergencyContact(updatedContacts[index]);

        // If errors exist, update; otherwise, remove the entry
        if (Object.keys(contactErrorsForIndex).length > 0) {
            updatedErrors[index] = contactErrorsForIndex;
        } else {
            delete updatedErrors[index];
        }

        setContactErrors(updatedErrors);

        // Check if all emergency contacts are valid
        const allFieldsValid = updatedContacts.every((contact, i) => {
            return Object.keys(validateEmergencyContact(contact)).length === 0;
        });

        setIsContactsValid(allFieldsValid);
    };

    // Submit Handler with Validation
    const handleEmergencySubmit = async (event) => {
        event.preventDefault();

        const newErrors = { ...contactErrors };
        // Regex for letters and spaces only
        // Validate each contact entry before submission
        emergencyContacts.forEach((contact, index) => {
            const errors = validateEmergencyContact(contact);
            if (Object.keys(errors).length > 0) {
                newErrors[index] = errors;
            }
        });

        setContactErrors(newErrors);
        // Prevent submission if errors exist
        if (Object.keys(newErrors).length > 0) return;
        const noErrors = Object.keys(newErrors).length === 0;

        const sanitizedEmergencyContacts = emergencyContacts?.map(({ __typename, ...contact }) => contact);
        const input = {
            emergencyContacts: sanitizedEmergencyContacts,
        }
        setIsContactsValid(Object.keys(noErrors).length === 0);

        try {
            const val = await handleSubmit({
                noErrors,
                formValid: isContactsValid, // ✅ Use `noErrors` instead of old state
                dataObj: input,
                action: "EmergencyContactworkHistory",
                ModalName: "clientModelpopUp",
                submitAction: "handleClientSubmit",
            });
            if (val) {
                dispatch(setEmergencyContactes(sanitizedEmergencyContacts));
                setIsContactsValid(false)
            }
        } catch (error) {

        } finally {

            setIsContactsValid(false); // Ensure form state resets
        }
    };
    // Add New Emergency Contact Entry
    const addNewContact = () => {
        setEmergencyContacts((prev) => [...prev, { name: "", relationship: "", phoneNumber: "" }]);
        setIsContactsValid(false);
    };
    // Delete Emergency Contact Entry and Re-index Errors
    const handleDeleteContact = (index) => {
        handleDeleteItem(index, emergencyContacts, setEmergencyContacts, contactErrors, setContactErrors, setIsContactsValid);
    };


    return (

        <Modal id="emergency_contact_modal" title="Emergency Contact"
            handleModalClose={() => handleClose(
                contactup,
                setEmergencyContacts,
                setContactErrors,
                setIsContactsValid)}
            handleSubmit={handleEmergencySubmit}
            isUserDataValid={false}>
            {emergencyContacts?.map((contact, index) => (
                <div key={index} className="card ">
                    <div className="card-body">
                        <h3 className="card-title">Emergency Contact {index + 1}
                            <Link to="#" className="delete-icon" onClick={() => handleDeleteContact(index)}>
                                <i className="fa-regular fa-trash-can" />
                            </Link>
                        </h3>
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                <InputField
                                    formcontrol="form-control"
                                    type="text"
                                    label="Name"
                                    name="name"
                                    required={true}
                                    value={contact?.name || ''}
                                    onChange={(e) => handleEmergencyChange(index, e)}
                                    error={contactErrors[index]?.name}
                                />

                            </div>
                            <div className="col-md-6 mb-2">

                                <InputField
                                    formcontrol="form-control"
                                    type="text"
                                    label="Relationship"
                                    name="relationship"
                                    required={true}
                                    value={contact?.relationship || ''}
                                    onChange={(e) => handleEmergencyChange(index, e)}
                                    error={contactErrors[index]?.relationship}

                                />

                            </div>
                            <div className="col-md-6 mb-2">

                                <InputField
                                    formcontrol="form-control"
                                    type="text"
                                    label="Phone"
                                    name="phoneNumber"
                                    required={true}
                                    value={contact?.phoneNumber || ''}
                                    onChange={(e) => handleEmergencyChange(index, e)}
                                    error={contactErrors[index]?.phoneNumber}

                                />

                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <div className="add-more">
                <Link to="#" onClick={addNewContact}>
                    <i className="fa-solid fa-plus-circle" /> Add More
                </Link>
            </div>

        </Modal>


    )
}